export class DosageModel {
    sglRecDose: number
    sglMinDose: number
    sglMaxDose: number
    sglQty: number = 1
    QtyUnit: string = 'mg' 
    constructor(
        sglRecDose: number,
        sglMinDose: number,
        sglMaxDose: number,
        sglQty: number,
        QtyUnit: string,
    ) {
        this.sglRecDose = sglRecDose
        this.sglMinDose = sglMinDose
        this.sglMaxDose = sglMaxDose
        this.sglQty = sglQty
        this.QtyUnit = QtyUnit
    }
}